(function () {
  'use strict';

  // Desktop drag-to-scroll for the collection link-card carousel.
  // Touch devices scroll natively; this covers mouse users.
  document.querySelectorAll('[data-drag-scroll]').forEach(function (track) {
    var isDown = false;
    var moved = false;
    var startX = 0;
    var startScroll = 0;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      isDown = true;
      moved = false;
      startX = e.clientX;
      startScroll = track.scrollLeft;
    });

    track.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var delta = e.clientX - startX;
      if (Math.abs(delta) > 5 && !moved) {
        moved = true;
        track.classList.add('is-dragging');
      }
      if (moved) track.scrollLeft = startScroll - delta;
    });

    function release() {
      if (!isDown) return;
      isDown = false;
      setTimeout(function () {
        track.classList.remove('is-dragging');
      }, 0);
    }

    track.addEventListener('pointerup', release);
    track.addEventListener('pointerleave', release);

    // Suppress the click that follows a drag so cards don't navigate.
    track.addEventListener('click', function (e) {
      if (moved) {
        e.preventDefault();
        moved = false;
      }
    }, true);
  });
})();
